import { useState } from 'react'

import { toast } from '@octane/spark'
import { getMaterialKit } from 'api/dealership'
import { OctaneLogger } from 'integrations/datadog/OctaneLogger'
import { DealershipInfo } from 'state/user/UserState'
import parseContentDisposition from 'utils/parseContentDisposition'

export const onCopyLink = (flexLink?: string) => {
    if (!flexLink) return

    navigator.clipboard.writeText(flexLink)

    toast(flexLink ?? '', {
        closeIcon: true,
        duration: 3000,
        position: 'bottom-center',
        size: 'medium',
        title: 'Copied to clipboard!',
        variant: 'success',
    })

    OctaneLogger.info('Prequal Flex link copied')
}

export const onDownloadKit = async (dealership?: DealershipInfo) => {
    if (!dealership) return

    const response = await getMaterialKit(dealership?.id)
    const link = document.createElement('a')
    const url = window.URL.createObjectURL(new Blob([response.data]))

    link.href = url

    const filename =
        parseContentDisposition(response.headers['content-disposition']) ??
        `Octane Prequal Flex Kit - [${dealership?.name}].pdf`

    link.setAttribute('download', filename)

    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(url)
    link.remove()

    OctaneLogger.info('Prequal Flex kit downloaded')
}

export const useDownloadKit = () => {
    const [downloading, setDownloading] = useState(false)

    const downloadKit = async (dealership?: DealershipInfo) => {
        if (downloading) return

        setDownloading(true)

        try {
            await onDownloadKit(dealership)
        } catch {
            toast('', {
                closeIcon: true,
                duration: 3000,
                position: 'bottom-center',
                size: 'medium',
                title: "We couldn't download your kit. Please try again.",
                variant: 'error',
            })
        } finally {
            setDownloading(false)
        }
    }

    return { downloading, downloadKit }
}
